// extracted by mini-css-extract-plugin
module.exports = {"loader":"marketplaceIndex_loader__1LXCY"};